/* global growsumo */
import { getCurrentURL } from '../components/ModalForm/helpers/services';

/* Ignore internal emails as they can be used when testing in production. */
function isExternalEmail(email) {
  return !(email || '').toLowerCase().includes('@remote.com');
}

function createSignup({ email, formName, id }) {
  return new Promise((resolve) => {
    if (growsumo && isExternalEmail(email)) {
      growsumo.data.name = formName;
      growsumo.data.email = `${id}@remote.com`;
      growsumo.data.customer_key = id;
      growsumo.createSignup(resolve);
    } else {
      resolve();
    }
  });
}

function getPartnerStackGroup() {
  const utm = getCurrentURL();
  const utmUrlParams = new URLSearchParams(utm);

  return utmUrlParams.get('utm_campaign') || '';
}

function getPartnerStackInfo() {
  let pspartnerkey = '';

  if (typeof growsumo !== 'undefined' && growsumo && growsumo.data) {
    pspartnerkey = growsumo.data.partner_key;
  }

  return {
    pspartnerkey,
    pspartner_group: getPartnerStackGroup(),
  };
}

export { createSignup, getPartnerStackInfo };
